"use client";

import {
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger,
} from "@/components/ui/drawer";
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
} from "@/components/ui/sheet";
import { Label } from "@/components/ui/label";
import { useIsMobile } from "@/hooks/use-mobile";
import { IconQuestionMark } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
interface BlockInputProps {
    title?: string;
    subtitle?: string;
    tooltip?: string;
    children?: React.ReactNode;
    subchildren?: React.ReactNode;
    inline?: boolean;
    subchildrenHide?: boolean;
}

export default function BlockParent({
    title,
    subtitle,
    tooltip,
    children,
    subchildren,
    inline = false,
    subchildrenHide,
}: BlockInputProps) {
    const isMobile = useIsMobile();

    return (
        <div className={cn("flex flex-col gap-1 rounded-md")}>
            <div
                className={cn(
                    "flex flex-col gap-1",
                    inline && "flex-row items-center"
                )}
            >
                {title && (
                    <div className="flex items-center gap-1">
                        <Label variant={"toggle"}>{title}</Label>
                        {tooltip &&
                            (isMobile ? (
                                <Drawer>
                                    <DrawerTrigger className="rounded-full border border-muted-foreground bg-accent/50">
                                        <IconQuestionMark
                                            size={14}
                                            className="text-foreground"
                                        />
                                    </DrawerTrigger>
                                    <DrawerContent>
                                        <DrawerHeader>
                                            <DrawerTitle>{title}</DrawerTitle>
                                        </DrawerHeader>
                                        <div className="px-4 pb-4">
                                            <p>{tooltip}</p>
                                        </div>
                                        <DrawerFooter>
                                            <DrawerClose asChild>
                                                <Button variant="outline">
                                                    Close
                                                </Button>
                                            </DrawerClose>
                                        </DrawerFooter>
                                    </DrawerContent>
                                </Drawer>
                            ) : (
                                <Sheet>
                                    <SheetTrigger className="rounded-full border border-muted-foreground bg-accent/50">
                                        <IconQuestionMark
                                            size={14}
                                            className="text-foreground"
                                        />
                                    </SheetTrigger>
                                    <SheetContent side={"bottom"}>
                                        <SheetHeader className="flex flex-row items-center gap-2">
                                            <SheetTitle className="!mt-0">
                                                {title}
                                            </SheetTitle>
                                        </SheetHeader>
                                        <p>{tooltip}</p>
                                    </SheetContent>
                                </Sheet>
                            ))}
                    </div>
                )}
                {subtitle && <Label variant={"subtoggle"}>{subtitle}</Label>}
                {children}
            </div>
            {!subchildrenHide && subchildren}
        </div>
    );
}
